import { QUERY_RESULT_CACHE_KEY } from '../Containers/Docs/constants';
import { IQueryResponse } from '../Types/Docs';

export interface IQueryResultCache {
  query: string;
  topK: number;
  jobId: string;
  result: IQueryResponse;
  cachedAt: string;
}

export const saveQueryResultCache = (cache: Omit<IQueryResultCache, 'cachedAt'>): void => {
  try {
    const entry: IQueryResultCache = {
      ...cache,
      cachedAt: new Date().toISOString(),
    };
    sessionStorage.setItem(QUERY_RESULT_CACHE_KEY, JSON.stringify(entry));
  } catch {
    // Ignore quota or private-mode errors
  }
};

export const getQueryResultCache = (): IQueryResultCache | null => {
  try {
    const stored = sessionStorage.getItem(QUERY_RESULT_CACHE_KEY);
    if (!stored) return null;

    const parsed = JSON.parse(stored) as Partial<IQueryResultCache>;
    if (
      !parsed ||
      typeof parsed.query !== 'string' ||
      typeof parsed.topK !== 'number' ||
      typeof parsed.jobId !== 'string' ||
      !parsed.result ||
      typeof parsed.result.answer !== 'string'
    ) {
      return null;
    }

    return parsed as IQueryResultCache;
  } catch {
    return null;
  }
};

export const clearQueryResultCache = (): void => {
  try {
    sessionStorage.removeItem(QUERY_RESULT_CACHE_KEY);
  } catch {
    // Ignore storage errors
  }
};

export const doesQueryResultCacheMatch = (
  cache: IQueryResultCache,
  query: string,
  topK: number,
  jobId?: string | null
): boolean => {
  const queryMatches = cache.query === query && cache.topK === topK;
  if (!jobId) {
    return queryMatches;
  }
  return queryMatches && cache.jobId === jobId;
};
